import {TrackingFeatureTypes} from '../../../types';

type ShopFeatureActions = 'impression' | 'click' | 'submit' | 'close';

export type ShopFeatureEvent = {
  GA4: {
    event: 'feature';
    action: ShopFeatureActions;
    label: string | null;
    value: number | string | null;
    name: string;
    page_type?: string;
    page_type_id?: number;
  };
};

export const trackShopFeature =
  ({feature}: {feature: TrackingFeatureTypes}) =>
  (): ShopFeatureEvent | undefined => {
    // GTM substitutes 'unspecified' for a missing name, which makes the event
    // useless for analytics - drop it instead of pushing it to the dataLayer.
    if (!feature.name) {
      return undefined;
    }

    const eventGA4: ShopFeatureEvent['GA4'] = {
      event: 'feature',
      action: feature.type as ShopFeatureActions,
      label: feature.label,
      value: feature.value,
      page_type: feature.page_type,
      page_type_id: feature.page_type_id,
      name: feature.name,
    };

    // For this particular event, there is no distinction between GA3/GA4.
    // One feature dataLayer event will send an event to both analytics tools.
    const event = {
      GA4: eventGA4,
    };

    return event;
  };
